import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { NodeViewDecorator, StrikethroughDecoration } from './../../ricos-types/index.js';

const decorator = (element: JSX.Element, strikethroughDecoration: StrikethroughDecoration) => {
  const { strikethroughData } = strikethroughDecoration;
  const isStrikethrough = typeof strikethroughData === 'undefined' || strikethroughData;
  return (
    <s
      key={`strikethrough-${element?.key}`}
      style={{ textDecoration: isStrikethrough ? 'line-through' : 'none' }}
    >
      {element}
    </s>
  );
};

const StrikethroughDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.STRIKETHROUGH),
  decorate: ({ element, node }) => {
    const strikethroughDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.STRIKETHROUGH
    ) as StrikethroughDecoration;
    return decorator(element as JSX.Element, strikethroughDecoration);
  },
};

export default StrikethroughDecorator;
